import { Controller } from '../utils/controller';
import { iframeResizer } from 'iframe-resizer';

export default class extends Controller {
  static targets = ['output'];
  static requiredTargets = [];

  declare outputTarget: HTMLElement;
  declare readonly hasOutputTarget: boolean;

  // LOCAL STATE
  private resizer: iframeResizer;

  initialize() {
    if (this.hasOutputTarget) {
      this.resizer = iframeResizer(
        {
          checkOrigin: false,
          heightCalculationMethod: 'bodyScroll',
          waitForLoad: true,
          warningTimeout: 0,
          onScroll: () => {
            return false;
          }
        },
        this.outputTarget
      );
    }

    return this.resizer;
  }
}
